import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import EnterpriseIcon, { ChevronDownIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React, { useState, useEffect } from 'react';
import Button from '../Button.js';
import { Dropdown } from '../Dropdown.js';

var TabsOverflowDropdown = function TabsOverflowDropdown(_ref) {
  var _classnames, _activeLabel$;
  var activeItem = _ref.activeItem,
    onSelect = _ref.onSelect,
    size = _ref.size,
    justified = _ref.justified,
    isActive = _ref.isActive,
    propsItems = _ref.items;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    menuActive = _useState4[0],
    setMenuActive = _useState4[1];
  useEffect(function () {
    setItems(Object.values(propsItems));
  }, [propsItems]);
  useEffect(function () {
    setMenuActive(isActive(activeItem, items));
  }, [activeItem, isActive, propsItems]);
  var buttonClasses = classnames('C-Tabs__Button', (_classnames = {}, _defineProperty(_classnames, "--size-".concat(size), size), _defineProperty(_classnames, '--space-between', justified), _classnames));
  var activeLabel = items.filter(function (item) {
    return item.name === activeItem;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown, {
    size: size,
    location: "bottom-right",
    className: menuActive ? '--isActive' : ''
  }, /*#__PURE__*/React.createElement(Button, {
    className: buttonClasses
  }, menuActive ? (_activeLabel$ = activeLabel[0]) === null || _activeLabel$ === void 0 ? void 0 : _activeLabel$.label : 'More', /*#__PURE__*/React.createElement(EnterpriseIcon, {
    icon: ChevronDownIcon,
    className: "hc-ml-dense",
    size: "inline"
  })), /*#__PURE__*/React.createElement(Dropdown.Menu, null, items.map(function (item) {
    var _item$otherProps;
    var itemClassNames = [];
    // add isSelected if it matches selected item
    if (item.active || item.name === activeItem) {
      itemClassNames.push('isSelected');
    }
    // add passed in classNames if applicable
    if ((_item$otherProps = item.otherProps) !== null && _item$otherProps !== void 0 && _item$otherProps.className) {
      var _item$otherProps2;
      itemClassNames.push([(_item$otherProps2 = item.otherProps) === null || _item$otherProps2 === void 0 ? void 0 : _item$otherProps2.className]);
    }
    return /*#__PURE__*/React.createElement(Dropdown.MenuItem, _extends({}, item.otherProps, {
      key: "".concat(item.name, "_menuItem"),
      className: itemClassNames,
      "aria-selected": item.active || item.name === activeItem,
      onClick: function onClick(e) {
        return typeof onSelect === 'function' && onSelect(e, item);
      }
    }), item.label);
  }))));
};
TabsOverflowDropdown.displayName = 'TabsOverflowDropdown';

export { TabsOverflowDropdown as default };
